import { Component, ChangeDetectionStrategy, input, output, signal, computed, effect } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-slider',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="slider-ust">
      @if (etiket()) { <span class="slider-etiket">{{ etiket() }}</span> }
      <span class="slider-deger" [style.color]="renk()">{{ ic_deger() }}</span>
    </div>
    <div class="slider-track-wrap">
      <div class="slider-dolgu" [style.width.%]="yuzdeDolgu()" [style.background]="renk()"></div>
      <input #sliderRef type="range"
             class="slider-input"
             [min]="min()" [max]="max()" [step]="adim()"
             [value]="ic_deger()"
             [style.--sl-renk]="renk()"
             (input)="degerDegisti($event)" />
    </div>
  `,
  styles: [`
    :host { display: block; }
    .slider-ust {
      display: flex; align-items: center; justify-content: space-between;
      margin-bottom: 6px; gap: 8px;
    }
    .slider-etiket {
      font-size: 13px; font-weight: 500; color: var(--py-metin, #e0e0e0);
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
      flex: 1; min-width: 0;
    }
    .slider-deger {
      font-size: 14px; font-weight: 600; font-variant-numeric: tabular-nums;
      flex-shrink: 0;
    }
    .slider-track-wrap {
      position: relative; height: 20px;
      display: flex; align-items: center;
    }
    .slider-dolgu {
      position: absolute; left: 0; top: 50%;
      height: 4px; border-radius: 2px;
      transform: translateY(-50%);
      pointer-events: none; z-index: 0;
      transition: width 0.05s linear;
    }
    .slider-input {
      -webkit-appearance: none; appearance: none;
      width: 100%; height: 4px; border-radius: 2px;
      background: rgba(255,255,255,0.12);
      outline: none; cursor: pointer;
      position: relative; z-index: 1;
      margin: 0;
    }
    .slider-input::-webkit-slider-thumb {
      -webkit-appearance: none; appearance: none;
      width: 16px; height: 16px; border-radius: 50%;
      background: #fff; border: 2px solid var(--sl-renk, #1890ff);
      box-shadow: 0 1px 4px rgba(0,0,0,0.3);
      cursor: pointer;
      transition: transform 0.15s ease, box-shadow 0.15s ease;
    }
    .slider-input::-webkit-slider-thumb:hover {
      transform: scale(1.25);
      box-shadow: 0 0 0 4px rgba(24,144,255,0.15), 0 1px 4px rgba(0,0,0,0.3);
    }
    .slider-input::-moz-range-thumb {
      width: 16px; height: 16px; border-radius: 50%;
      background: #fff; border: 2px solid var(--sl-renk, #1890ff);
      box-shadow: 0 1px 4px rgba(0,0,0,0.3);
      cursor: pointer;
      transition: transform 0.15s ease, box-shadow 0.15s ease;
    }
    .slider-input::-moz-range-thumb:hover {
      transform: scale(1.25);
      box-shadow: 0 0 0 4px rgba(24,144,255,0.15), 0 1px 4px rgba(0,0,0,0.3);
    }
    .slider-input::-moz-range-track {
      background: transparent; border: none; height: 4px;
    }
    .slider-input::-webkit-slider-runnable-track {
      background: transparent; height: 4px;
    }
  `],
})
export class SliderComponent {
  deger = input(50);
  min = input(0);
  max = input(100);
  adim = input(1);
  etiket = input('');
  renk = input('#1890ff');
  degisti = output<number>();

  ic_deger = signal(50);

  yuzdeDolgu = computed(() => {
    const aralik = this.max() - this.min();
    if (aralik <= 0) return 0;
    return ((this.ic_deger() - this.min()) / aralik) * 100;
  });

  constructor() {
    effect(() => this.ic_deger.set(this.deger()));
  }

  degerDegisti(e: Event) {
    const val = +(e.target as HTMLInputElement).value;
    this.ic_deger.set(val);
    this.degisti.emit(val);
  }
}
